import React from 'react';
import { BoxIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string | number;
  change?: string;
  isPositive?: boolean;
  icon?: BoxIcon;
  subtitle?: string;
}
const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  change,
  isPositive = true,
  icon: Icon,
  subtitle
}) => {
  return <div className="rounded-sm border border-gray-200 bg-white p-6 shadow-sm" data-id="element-955">
      <div className="flex items-center justify-between mb-2" data-id="element-956">
        <p className="text-sm font-medium text-gray-600" data-id="element-957">{title}</p>
        {Icon && <Icon className="h-5 w-5 text-gray-400" data-id="element-958" />}
      </div>
      <div className="flex items-baseline gap-2" data-id="element-959">
        <p className="text-2xl font-bold text-gray-900" data-id="element-960">{value}</p>
        {change && <span className={`text-sm font-medium ${isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-961">
            {isPositive ? '↑' : '↓'} {change}
          </span>}
      </div>
      {subtitle && <p className="mt-1 text-xs font-normal text-gray-500" data-id="element-962">{subtitle}</p>}
    </div>;
};
export default MetricCard;